import { Lock, Square, SquareCheckBig } from 'lucide-react';
import React, { useEffect } from 'react';
import { cn } from '@/lib/utils';
import { useController } from 'react-hook-form';

const formatBedLabel = (prefix, bedNumber) => `${prefix}${String(bedNumber).padStart(2, '0')}`;

const BedSlotSelector = ({ dryingBeds, control, startOfDrying, lot }) => {
  const {
    field: { value: beds, onChange },
  } = useController({
    name: 'drying_beds',
    control,
  });

  const isSelected = (bed_number, bed_position) =>
    beds.some(b => b.bed_number === bed_number && b.bed_position === bed_position);

  const toggleBed = (bed_number, bed_position) => {
    const exists = isSelected(bed_number, bed_position);

    if (exists) {
      onChange(beds.filter(b => !(b.bed_number === bed_number && b.bed_position === bed_position)));
    } else {
      const alreadyExists = beds.some(b => b.bed_number === bed_number && b.bed_position === bed_position);
      if (!alreadyExists) {
        onChange([
          ...beds,
          {
            bed_number,
            bed_position,
            drying_start_time: startOfDrying,
            lot_id: lot?._id,
            lot_number: lot?.lot_number,
            lotname: lot?.lotname,
            estate_id: lot?.estate_id,
          },
        ]);
      }
      // onChange([
      //   ...beds,
      //   {
      //     bed_number,
      //     bed_position,
      //     drying_start_time: startOfDrying,
      //     lot_id: lot?._id,
      //     lot_number: lot?.lot_number,
      //     lotname: lot?.lotname,
      //     estate_id: lot?.estate_id,
      //   },
      // ]);
    }
  };

  useEffect(() => {
    if (!startOfDrying || !beds?.length) return;

    const updatedBeds = beds.map(bed => ({
      ...bed,
      drying_start_time: startOfDrying,
    }));

    onChange(updatedBeds);
  }, [startOfDrying]);

  return (
    <div className="grid grid-cols-3 gap-2">
      {dryingBeds?.map(bed => {
        return (
          // <BedItem key={bed._id} bed={bed} />
          <div key={bed._id} className="rounded border border-[#E5E7EB]">
            {/* Upper */}
            {bed.upper_bed.is_empty ? (
              <label
                onClick={() => toggleBed(bed.bed_number, 'upper')}
                className={cn(
                  'flex cursor-pointer items-center gap-2 rounded-t p-1.5',
                  isSelected(bed.bed_number, 'upper') && 'bg-[#1F2937] text-white'
                )}
              >
                {isSelected(bed.bed_number, 'upper') ? (
                  <SquareCheckBig className="h-4 w-4" />
                ) : (
                  <Square className="h-4 w-4" />
                )}
                {formatBedLabel('U', bed.bed_number)}
              </label>
            ) : (
              <LockedBed bedNumber={formatBedLabel('U', bed.bed_number)} />
            )}

            {/* Middle Bed */}
            {bed.middle_bed.days === null ? (
              <label
                onClick={() => toggleBed(bed.bed_number, 'middle')}
                className={cn(
                  'flex cursor-pointer items-center gap-2 rounded-t p-1.5',
                  isSelected(bed.bed_number, 'middle') && 'bg-[#1F2937] text-white'
                )}
              >
                {isSelected(bed.bed_number, 'middle') ? (
                  <SquareCheckBig className="h-4 w-4" />
                ) : (
                  <Square className="h-4 w-4" />
                )}
                {formatBedLabel('M', bed.bed_number)}
              </label>
            ) : (
              <LockedBed bedNumber={formatBedLabel('M', bed.bed_number)} />
            )}

            {/* Lower */}
            {bed.lower_bed.is_empty ? (
              <label
                onClick={() => toggleBed(bed.bed_number, 'lower')}
                className={cn(
                  'flex cursor-pointer items-center gap-2 rounded-b p-1.5',
                  isSelected(bed.bed_number, 'lower') && 'bg-[#1F2937] text-white'
                )}
              >
                {isSelected(bed.bed_number, 'lower') ? (
                  <SquareCheckBig className="h-4 w-4" />
                ) : (
                  <Square className="h-4 w-4" />
                )}
                {formatBedLabel('L', bed.bed_number)}
              </label>
            ) : (
              <LockedBed bedNumber={formatBedLabel('L', bed.bed_number)} />
            )}
          </div>
        );
      })}
    </div>
  );
};

const BedItem = ({ bed, onChange }) => {
  const isUpperBedEmpty = bed.upper_bed.is_empty;
  const isLowerSelected = bed.lower_bed.is_empty;

  return (
    <div key={bed._id} className="rounded border border-[#E5E7EB]">
      {isUpperBedEmpty ? (
        <label className={cn('flex items-center gap-2 rounded-t p-1.5', false && 'bg-[#1F2937] text-white')}>
          {isUpperBedEmpty ? <Square className="h-4 w-4" /> : <SquareCheckBig className="h-4 w-4" />}
          <div className="font-normal">{formatBedLabel('U', bed.bed_number)}</div>
        </label>
      ) : (
        <LockedBed bedNumber={formatBedLabel('U', bed.bed_number)} />
      )}

      {isLowerSelected ? (
        <label className={cn('flex items-center gap-2 rounded-b p-1.5', !isLowerSelected && 'bg-[#1F2937] text-white')}>
          {!isLowerSelected ? <SquareCheckBig className="h-4 w-4" /> : <Square className="h-4 w-4" />}

          <div className="font-normal">{formatBedLabel('U', bed.bed_number)}</div>
        </label>
      ) : (
        <LockedBed bedNumber={formatBedLabel('L', bed.bed_number)} />
      )}
    </div>
  );
};

export default BedSlotSelector;

const LockedBed = ({ bedNumber }) => {
  return (
    <label className={cn('flex items-center gap-2 rounded-b bg-[#F9FAFB] p-1.5 text-[#9FA6B1]')}>
      <Lock className="h-4 w-4" />

      <div className="font-normal">{bedNumber}</div>
    </label>
  );
};
